import React, { useState } from "react";
import { useEffect } from "react";
import { Helmet } from 'react-helmet-async';
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import { getJobs } from "../../../../api/jobs";
import { apiErrorHandler } from "../../../../helpers/common";
import Selected from "../../../../helpers/Common/Selected";
import SmallLoader from "../../../../helpers/Common/SmallLoader";
import JobItemRow from "./JobItemRow";
import NoJobsPage from "./NoJobsPage";
import Section from "./Section";

const ManageJobs = () => {
  const employer = useSelector((state) => state.employer);
  const jobLoading = employer.loading;
  const [loading, setLoading] = useState(false);
  const { companyId, companyName } = useParams();
  const [jobs, setJobs] = useState([]);
  const customer = useSelector((state) => state.customer.profile);
  const [activeTab, setActiveTab] = useState("1");

  // fetching openening jobs if company id is available or set job list
  useEffect(() => {
    if (companyId) {
      setLoading(true);
      const params = `&JobsSearch[employer_id]=${customer.id}&JobsSearch[job_company_id]=${companyId}`;
      getJobs(params)
        .then((res) => {
          if (res.status === 200) {
            setJobs(res.data);
          }
        })
        .catch((err) => {
          console.log("err::", err);
          apiErrorHandler(err);
        })
        .finally(() => setLoading(false));
    } else {
      setJobs(employer?.jobs);
    }
  }, [companyId, customer.id, employer?.jobs]);

  const activeJobs = jobs?.filter((job) => job.is_active === 1);
  const disabledJobs = jobs?.filter((job) => job.is_active === 0);

  return (
    <React.Fragment>
      <Helmet>
        <title>Manage Jobs | Jobseekers Page </title>
      </Helmet>

      <Section
        title={companyId && companyName}
        currentPageName={companyId && "Opening Jobs"}
      />

      {(jobLoading || loading) && <SmallLoader />}

      <section
        className="section"
        style={{ display: jobLoading || loading ? "none" : "block" }}
      >
        <Container>
          {jobs && jobs.length > 0 ? (
            <>
              <Selected
                itemData={jobs}
                buttonText="Add A New Job"
                buttonUrl={
                  companyId
                    ? `/employer/job/add/${companyId}/${companyName}`
                    : "/employer/job/add"
                }
              />

              <Row className="justify-content-center mt-3">
                <Col lg={8}>
                  <Nav
                    tabs
                    className="job-list-menu nav-pills nav-justified flex-column flex-sm-row mb-4"
                    role="tablist"
                  >
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" })}
                        onClick={() => setActiveTab("1")}
                        type="button"
                        role="tab"
                      >
                        Active Jobs ({activeJobs?.length || 0})
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" })}
                        onClick={() => setActiveTab("2")}
                        type="button"
                        role="tab"
                      >
                        Disabled Jobs ({disabledJobs?.length || 0})
                      </NavLink>
                    </NavItem>
                  </Nav>
                </Col>
              </Row>

              <Row>
                <Col lg={12}>
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                      {activeJobs.map((job) => (
                        <JobItemRow jobDetails={job} key={job.id} />
                      ))}
                      {activeJobs.length === 0 && <p className="text-center">No active jobs found.</p>}
                    </TabPane>
                    <TabPane tabId="2">
                      {disabledJobs.map((job) => (
                        <JobItemRow jobDetails={job} key={job.id} />
                      ))}
                      {disabledJobs.length === 0 && (
                        <p className="text-center">No disabled jobs found.</p>
                      )}
                    </TabPane>
                  </TabContent>
                </Col>
              </Row>
            </>
          ) : (
            <NoJobsPage
              message="No job posted yet."
              buttonUrl={
                companyId
                  ? `/employer/job/add/${companyId}/${companyName}`
                  : "/employer/job/add"
              }
            />
          )}
        </Container>
      </section>
    </React.Fragment>
  );
};

export default ManageJobs;
